export enum Color {
  /*
   * Colors in the Design System
   * Reference: https://www.figma.com/design/sjVw2qSQGLSFCnz6yTlQkz/Design-System?node-id=14947-8193&t=b50HrOlM0jmsGwCl-4
   * Keep in sync with: libs/foundation/src/css/variables/colors.css
   * Last updated: 15 August 2025
   */

  /* Brand */
  Brand10 = '#fde4e3',
  Brand20 = '#f9b2b0',
  Brand30 = '#f58b88',
  Brand40 = '#f26561',
  Brand50 = '#ef3e39',
  Brand60 = '#bf322e',
  Brand70 = '#8f2522',
  Brand80 = '#601917',
  Brand90 = '#481311',

  /* Primary */
  Primary10 = '#e5f5ff',
  Primary20 = '#bce3ff',
  Primary30 = '#93d0ff',
  Primary40 = '#5a9fe9',
  Primary50 = '#206dd2',
  Primary60 = '#1058b8',
  Primary70 = '#00429d',
  Primary80 = '#003475',
  Primary90 = '#00254d',

  /* Secondary */
  Secondary10 = '#e1f2f1',
  Secondary20 = '#cbe9e6',
  Secondary30 = '#b5e0db',
  Secondary40 = '#6bb2a7',
  Secondary50 = '#218372',
  Secondary60 = '#1f7868',
  Secondary70 = '#1d6c5e',
  Secondary80 = '#164e44',
  Secondary90 = '#0e2f29',

  /* Grey */
  Grey10 = '#f6f7f8',
  Grey20 = '#e5e6e6',
  Grey30 = '#ababab',
  Grey40 = '#707070',
  Grey50 = '#424242',
  Grey60 = '#353535',
  Grey70 = '#282828',
  Grey80 = '#1a1a1a',
  Grey90 = '#0d0d0d',

  /* White */
  White = '#fff',

  /* Watermelon */
  Watermelon10 = '#fee9ea',
  Watermelon20 = '#febec3',
  Watermelon30 = '#fd9ea6',
  Watermelon40 = '#fd7d88',
  Watermelon50 = '#fc5d6a',
  Watermelon60 = '#ca4a55',
  Watermelon70 = '#973840',
  Watermelon80 = '#65252a',
  Watermelon90 = '#4c1c20',

  /* Mandarin */
  Mandarin10 = '#ffede0',
  Mandarin20 = '#ffceaa',
  Mandarin30 = '#ffb175',
  Mandarin40 = '#ff9d51',
  Mandarin50 = '#ff872c',
  Mandarin60 = '#db6b16',
  Mandarin70 = '#b65811',
  Mandarin80 = '#76390c',
  Mandarin90 = '#542807',

  /* Lemon */
  Lemon10 = '#fff7d7',
  Lemon20 = '#fdedb4',
  Lemon30 = '#fce38e',
  Lemon40 = '#fbda69',
  Lemon50 = '#fad143',
  Lemon60 = '#ad902f',
  Lemon70 = '#857024',
  Lemon80 = '#64541b',
  Lemon90 = '#4b3f14',

  /* Apple */
  Apple10 = '#e7f3e2',
  Apple20 = '#badcad',
  Apple30 = '#97cb85',
  Apple40 = '#75b95c',
  Apple50 = '#52a833',
  Apple60 = '#428629',
  Apple70 = '#31651f',
  Apple80 = '#214314',
  Apple90 = '#19320f',

  /* Mint */
  Mint10 = '#e0f2ee',
  Mint20 = '#a5dace',
  Mint30 = '#78c8b6',
  Mint40 = '#4bb59d',
  Mint50 = '#1ea385',
  Mint60 = '#18826a',
  Mint70 = '#126250',
  Mint80 = '#0c4135',
  Mint90 = '#093128',

  /* Blueberry */
  Blueberry10 = '#deeffc',
  Blueberry20 = '#a0d1f6',
  Blueberry30 = '#71baf1',
  Blueberry40 = '#41a3ed',
  Blueberry50 = '#128ce8',
  Blueberry60 = '#0e70ba',
  Blueberry70 = '#0b548b',
  Blueberry80 = '#07385d',
  Blueberry90 = '#052a46',

  /* Grape */
  Grape10 = '#efe7ff',
  Grape20 = '#d1b9ff',
  Grape30 = '#bb95ff',
  Grape40 = '#a472ff',
  Grape50 = '#8d4fff',
  Grape60 = '#713fcc',
  Grape70 = '#552f99',
  Grape80 = '#382066',
  Grape90 = '#2a184c',

  /* Error */
  Error10 = '#fdeae9',
  Error20 = '#ffc3c3',
  Error30 = '#fc8f8d',
  Error40 = '#f95553',
  Error50 = '#dd201d',
  Error60 = '#c01e1c',
  Error70 = '#8b1715',
  Error80 = '#621110',
  Error90 = '#420e0d',

  /*
   * Colors not defined in the Design System, but widely used
   */

  /* Other colors */
  GreyLighter = '#d4d4d4',
}

export type ColorName = keyof typeof Color
